import { ModelBase } from 'store/model-base';

export class ReturnEligibility extends ModelBase {
    public static storeName: string = 'returnEligibility';

    public orderItemId: string;
    public returnEligibility: boolean;
    public exchangeEligibility: boolean;
}
